import React from 'react'
import Link from 'gatsby-link'
import moment from 'moment'

import { Constrain } from '../@primitives/constrain'

import styled, { css } from 'react-emotion'
import { colors, fonts } from '../../styles/vars'

import whiteLogo from '../Logos/avi_white.svg'
import seanLogo from '../Logos/sean.svg'
import { Button } from '../@primitives/button'

const Grid = styled('div')`
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1.6fr;
  grid-gap: 20px 45px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  h4 {
    margin-bottom: 0;
  }
  
  .logo {
    margin-bottom: 10px;
    display: block;
  }
  
  .full {
    grid-column: span 4;
    
    @media (max-width: 768px) {
      grid-column: span 2;
      columns: 1;
    }
  }

  a:not(.btn):not(.logo),
  p.transparent {
    opacity: 0.6;
  }

  ul {
    list-style: none;
    padding: 0;
    font-family: ${fonts.heading};
    font-weight: bold;
    font-size: 16px;
    line-height: 1.5;
  }

  li:not(:last-of-type) {
    margin-bottom: 10px;
  }

  a:not(.btn):not(.invisible) {
    font-family: ${fonts.heading};
    font-weight: bold;
    font-size: 16px;
    line-height: 1.5;
  }

  a:not(.btn) {
    color: ${colors.white};
    text-decoration: none;
    transition: all 0.15s ease-in-out;
    border-bottom: 1px solid transparent;
    padding-bottom: 6px;
    
    &.invisible {
      border: none;
      
      &:hover {
        border: none;
        opacity: 1;
      }
    }

    &:hover {
      border-color: ${colors.primary};
      transition: all 0.15s ease-in-out;
      opacity: 1;
    }
  }
  
  .subFooter {
    text-align: center;
    
    ul {
      margin: 0;
    }
    
    li {
      display: inline-block;
      font-size: 10px;
      font-family: ${fonts.body};
      font-weight: 400;
      
      
      a {
        padding-bottom: 0;
        opacity: 1 !important;
      }
     
      &:not(:last-of-type) {
        margin-right: 10px;
        
        &:after {
          content: "|";
          margin-left: 10px;
          opacity: 0.6;
        }
      }
      
      @media (min-width: 768px) {
        margin-bottom: 0;
      }
    }
  }
`

export const Footer = ({data}) =>
  <div className={css`background-color: ${colors.black}; color: ${colors.white};`}>
    <Constrain>
      <Grid>
        <div className={css`@media (max-width: 768px) { grid-column: span 2; columns: 2; }`}>
          <Link to={"/"} className="invisible logo">
            <img src={whiteLogo} alt=""/>
          </Link>
          <p className="small transparent">
            The NAF Exclusive Master Distributor serving the entire United States
          </p>
        </div>
        <div>
          <h4>Products</h4>
          <nav>
            <ul>
              {data.map((product, i) => {
                if (product.edges[0].node.frontmatter.category === 'Capping Valves') {
                  return (
                    <li key={i}>
                      <Link to={product.edges[0].node.frontmatter.path}>
                        {product.edges[0].node.frontmatter.category}
                      </Link>
                    </li>
                  )
                }
              })}
              {data.map((product, i) => {
                if (product.edges[0].node.frontmatter.category !== 'Capping Valves') {
                  return (
                    <li key={i}>
                      <Link to={product.edges[0].node.frontmatter.path}>
                        {product.edges[0].node.frontmatter.category}
                      </Link>
                    </li>
                  )
                }
              })}
            </ul>
          </nav>
        </div>
        <div>
          <h4>Locations</h4>
          <nav>
            <ul>
              <li className={css`opacity: 0.6;`}>Augusta, GA</li>
              <li className={css`opacity: 0.6;`}>Jacksonville, FL</li>
              <li>
                <a href="https://goo.gl/maps/BuDsAYfu2rx" target="_blank">
                  Statesboro, GA
                </a>
              </li>
            </ul>
          </nav>

          <h4>More Info</h4>
          <nav>
            <ul>
              <li>
                <Link to={"/about"}>About AVI</Link>
              </li>
            </ul>
          </nav>
        </div>
        <div className={css`@media (max-width: 768px) { grid-column: span 2; columns: 2; }`}>
          <h4 className={css`margin-bottom: 20px !important;`}>Contact Us</h4>
          <p className="small transparent">
            Physical Address:
          </p>
          <p className="small ">
            <a href="https://goo.gl/maps/ktAytAZoxezp9Lo17" target="_blank" className={"invisible"}>
              106 Raybon Anderson Blvd.<br />
              Statesboro, Ga. 30458
            </a>
          </p>
          <p className="small transparent">
            Call Toll Free:
          </p>
          <p className={css`margin-bottom: 45px;` + " small"}>
            <a href="tel:1-800-284-2293" className={"invisible"}>1-800-284-2293</a>
          </p>
          <Button to="/contact" className="btn">Contact Us</Button>
        </div>
        <div className="full subFooter">
          <ul>
            <li>©{moment().format('YYYY')} Advanced Valve and Instrument Inc.</li>
            <li>All Rights Reserved</li>
            <li>
              <a href={"http://advancedvalve.net/privacy-policy"} className="invisible" target={"_blank"}>Privacy Policy</a>
            </li>
            <li>
              <a href="http://advancedvalve.net/disclaimer" className="invisible" target="_blank">Disclaimer</a>
            </li>
          </ul>
        </div>
        <div className={css`text-align: center; align-content: center;` + " full"}>
          <a href="//madebypioneer.com" className={css`padding: 0; opacity: 1 !important;` + " invisible"} target="_blank">
            <img src={seanLogo} alt="" className={css`max-width: 35px; vertical-align: middle;`}/>
          </a>
        </div>
      </Grid>
    </Constrain>
  </div>



// WEBPACK FOOTER //
// ./src/components/Footer/index.js